import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { IQuickbetSelectionModel } from '../../../core/models/quickbet-selection.model';
import { ISRMSelectedQuestionAndAnswer } from '../../../core/models/srm.model';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import { GtmTrackingService } from '../../../core/services/gtmTracking/gtm-tracking.service';
import { ServiceClosureService } from '../../../lazy-modules/serviceClosure/service-closure.service';
import { quickbetConstants } from '../../constants/quickbet.constant';

@Component({
    selector: 'quickbet-partial-overlay',
    templateUrl: 'quickbet-partial-overlay.component.html',
    styleUrls: ['quickbet-partial-overlay.component.scss'],
    // eslint-disable-next-line
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class QuickbetPartialOverlayComponent {
    @Input() title: string;
    @Input() showCloseIcon: boolean;
    @Input() isQuickBet: boolean;
    @Input() selection: IQuickbetSelectionModel;
    @Input() slideDownAnimation: boolean;
    @Input() slideUpAnimation: boolean;
    @Input() showPriceChangeMessage: boolean;
    @Input() NWIndicatorShown: boolean;
    @Input() nativeIos: boolean;
    @Input() placeBetPending: { state: boolean };
    @Input() isSRMBet: boolean;
    @Input() selectedQuestionAndAnswers?: ISRMSelectedQuestionAndAnswer[];
    @Input() srmOdds: string;
    @Output() readonly reuseSelectionFn?: EventEmitter<void> = new EventEmitter();
    @Output() readonly closeFn: EventEmitter<boolean> = new EventEmitter();
    @Output() readonly openFullOverlayFn: EventEmitter<void> = new EventEmitter();
    @Output() readonly removeSelectionFn: EventEmitter<void> = new EventEmitter();

    constructor(
        protected serviceClosureService: ServiceClosureService,
        protected gtmService: GtmService,
        protected gtmTrackingService: GtmTrackingService,
    ) {}

    openFullOverlayFnHandler(): void {
        this.stakeClickGATrack();
        this.openFullOverlayFn.emit();
    }

    reuseSelection(): void {
        this.reuseSelectionFn?.emit();
    }

    closePanel(): void {
        this.closePanelGATrack();
        this.closeFn.emit();
    }

    removeSelectionFnHandler(): void {
        this.removeSelectionGATrack();
        this.removeSelectionFn.emit();
    }

    closePanelGATrack(): void {
        const module = this.gtmTrackingService.getTracking()?.module;
        this.gtmService.push('trackEvent', {
            eventCategory: quickbetConstants.QUICKBET,
            eventAction: quickbetConstants.EVENT_ACTION_CLOSE,
            eventLabel: quickbetConstants.EVENT_LABEL_OVERLAY,
            positionEvent: quickbetConstants.EVENT_LABEL_OVERLAY,
            locationEvent: module,
            eventDetails: quickbetConstants.EVENT_LABEL_OVERLAY,
        });
    }

    removeSelectionGATrack(): void {
        const module = this.gtmTrackingService.getTracking()?.module;
        this.gtmService.push('trackEvent', {
            eventCategory: quickbetConstants.QUICKBET,
            eventAction: quickbetConstants.EVENT_ACTION_CLOSE,
            eventLabel: quickbetConstants.EVENT_LABEL_OVERLAY,
            positionEvent: quickbetConstants.BET_SELECTION,
            locationEvent: module,
            eventDetails: this.selection.eventName,
        });
    }

    stakeClickGATrack(): void {
        const module = this.gtmTrackingService.getTracking()?.module;
        this.gtmService.push('trackEvent', {
            eventCategory: quickbetConstants.QUICKBET,
            eventAction: 'click',
            eventLabel: quickbetConstants.EVENT_LABEL_OVERLAY,
            positionEvent: quickbetConstants.BET_SELECTION,
            locationEvent: module,
            eventDetails: `${this.selection.eventName}-stakes`,
        });
    }
}
